const MileStone = () => {
  return (
    <div>
      {/* <div className="flex flex-col  items-center mx-auto text-left pt-[1rem] pb-[.5rem] w-[100%] "> */}
      <div className="flex flex-col justify-left max-w-[50rem] gap-3 mx-auto text-left pb-[.5rem] px-[2rem]">
        <hr className="w-full lg:w-[50rem] mx-[auto]" />
        {/* <div className=" flex flex-col justify-left  mt-[.6rem] "> */}
        <h1 className="text-[30px] sm:text-[40px] font-bold flex   items-center text-left pt-[10px]">
          Milestones
        </h1>
        {/* </div> */}
        {/* <p className="sm:text-center text-center">Journey From an Industry Pioneer to the Pakistani Vernacular</p> */}
      </div>

      <div className="flex flex-col justify-center  gap- max-w-[50rem] sm:mx-auto mx-[1rem] mb-[5rem]">
        <img
          src="/milestone/milestone-desktop.jpg"
          alt=""
          className="w-[100%] sm:flex hidden"
        />
        <img
          src="/milestone/milestone.jpg"
          alt=""
          className="w-[80%] sm:hidden flex "
        />
      </div>
    </div>
  );
};
export default MileStone;
